import React, { useEffect, useState } from 'react'
import Button from '../../../../ui/Button/Button'
import { createForm } from '../../../../utils/newforms/createForm'
import getFieldRenderObject from '../../../../utils/newforms/render/getFieldRenderObject'
import FormRender from '../../../../utils/newforms/render/FormRender'
import getFormValues from '../../../../utils/newforms/getFormValues'
import {
  SMS_DELIVERY_OPTIONS,
  SMS_SOURCE_OPTIONS,
  SMS_SUBMISSION_OPTIONS,
} from './smsUiUtils'
import './Sms.sass'

class SmsFiltersForm {
  constructor() {
    this.source = {
      field: {
        fieldId: 'source',
        fieldType: 'select',
        label: 'Тип повідомлення',
        required: false,
        getOptions: SMS_SOURCE_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
    this.submissionStatus = {
      field: {
        fieldId: 'submissionStatus',
        fieldType: 'select',
        label: 'Статус відправки',
        required: false,
        getOptions: SMS_SUBMISSION_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
    this.deliveryStatus = {
      field: {
        fieldId: 'deliveryStatus',
        fieldType: 'select',
        label: 'Статус доставки',
        required: false,
        getOptions: SMS_DELIVERY_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
    this.createdFromDate = {
      field: {
        fieldId: 'createdFromDate',
        fieldType: 'date',
        label: 'Дата від',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.createdToDate = {
      field: {
        fieldId: 'createdToDate',
        fieldType: 'date',
        label: 'Дата до',
        required: false,
      },
      render: getFieldRenderObject(),
    }
  }
}

const formDataFromFilters = (filters) => ({
  source: filters.source || '',
  submissionStatus: filters.submissionStatus || '',
  deliveryStatus: filters.deliveryStatus || '',
  createdFromDate: filters.createdFromDate || '',
  createdToDate: filters.createdToDate || '',
})

const filtersFromForm = (form) => {
  const values = getFormValues({ form })
  return {
    source: values.source || '',
    submissionStatus: values.submissionStatus || '',
    deliveryStatus: values.deliveryStatus || '',
    createdFromDate: values.createdFromDate || '',
    createdToDate: values.createdToDate || '',
  }
}

function SmsFilters({ filters, onChange, onApply, onReset, formKey = 0 }) {
  const [form, setForm] = useState(null)

  useEffect(() => {
    setForm(
      createForm({
        formPattern: new SmsFiltersForm(),
        formData: formDataFromFilters(filters),
      })
    )
    // Remount/reset only when parent bumps formKey (reset) or first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formKey])

  const setFormAndSync = (updater) => {
    setForm((prev) => {
      if (!prev) return prev
      const next = typeof updater === 'function' ? updater(prev) : updater
      onChange(filtersFromForm(next))
      return next
    })
  }

  return (
    <div className="SmsFilters">
      <div className="SmsFilters-Fields">
        <FormRender
          sections={[
            {
              fields: [
                'source',
                'submissionStatus',
                'deliveryStatus',
                'createdFromDate',
                'createdToDate',
              ],
            },
          ]}
          form={form}
          setForm={setFormAndSync}
          errors={false}
        />
        <div className="SmsFilters-Actions">
          <Button title="Застосувати" theme="solid" fill="accent" size={32} onClick={onApply} />
          <Button title="Скинути" theme="solid" fill="normal" size={32} onClick={onReset} />
        </div>
      </div>
    </div>
  )
}

export default SmsFilters
